import React, { useState } from "react";
//primereact
import { Tooltip } from "primereact/tooltip";
//components
import Modal from "../../../../components/modal/Modal";

const ModalWhatsApp = ({ visible, setVisible, messages }) => {
  const [newMessage, setNewMessage] = useState("");
  const [attachment, setAttachment] = useState(null);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleString();
  };

  const handleSendMessage = () => {
    if (newMessage.trim() !== "" || attachment) {
      // Add the new message to the messages array
      const newMsg = {
        id: `msg_${Date.now()}`,
        from: "5516992538331@c.us",
        body: newMessage,
        timestamp: Math.floor(Date.now() / 1000),
        type: "chat",
        isForwarded: false,
        hasMedia: !!attachment,
        media: attachment,
      };
      messages.push(newMsg);
      setNewMessage("");
      setAttachment(null);
    }
  };

  const handleAttachmentChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAttachment(URL.createObjectURL(file));
    }
  };

  return (
    <Modal
      dynamicTitle="Conversa no WhatsApp"
      visible={visible}
      onHide={() => setVisible(false)}
    >
      <div className="whatsapp-conversation">
        {messages.map((message) => (
          <div
            key={message.id}
            className={`message ${
              message.from === "5516992538331@c.us" ? "sent" : "received"
            }`}
          >
            <div className="message-body">
              <p>{message.body}</p>
              {message.hasMedia && (
                <img
                  src={message.media}
                  alt="attachment"
                  className="message-attachment"
                />
              )}
            </div>
            <div className="message-timestamp">
              <small>{formatTimestamp(message.timestamp)}</small>
            </div>
          </div>
        ))}
      </div>
      <div className="whatsapp-input-container">
        <input
          type="file"
          id="attachment"
          style={{ display: "none" }}
          onChange={handleAttachmentChange}
        />
        <label
          htmlFor="attachment"
          className="whatsapp-attach-button"
          data-pr-tooltip="Anexar arquivo"
        >
          <i className="fa fa-paperclip"></i>
        </label>
        <Tooltip target=".whatsapp-attach-button" position="top" />
        <input
          type="text"
          className="whatsapp-input"
          placeholder="Digite uma mensagem"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
        />
        <button className="whatsapp-send-button" onClick={handleSendMessage}>
          <i className="fa fa-paper-plane"></i>
        </button>
      </div>
    </Modal>
  );
};

export default ModalWhatsApp;
